import { buildUrl } from '@/common-utils/functions/restUtils';
import { client } from '@/common-utils/libraries/axios/axios';
import envelopesFields from '../../fields/envelopesFields';
import { DOWNLOAD_CODES } from '../apiUrls';
import downloadCodesFields from '../../fields/downloadCodesFields';

/**
 * @param {Object} responseData
 * @param {Object[]} responseData.items
 * @param {string} responseData.items[].uuid
 * @param {string} responseData.items[].accessCode
 * @param {string} responseData.items[].createdAt
 * @param {string} responseData.items[].downloadServerIpAddressPort
 * @param {string} responseData.items[].scheduledEndDate
 * @param {string} responseData.items[].scheduledStartDate
 * @param {string} responseData.items[].downloadCodeName
 * @param {string} responseData.items[].createdBy
 * @param {number} responseData.totalResults
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    const data = {};
    const mappedItems = items.map(item => ({
        [envelopesFields.UUID.key]: item[envelopesFields.UUID.key],
        [envelopesFields.ACCESS_CODE.key]: item[envelopesFields.ACCESS_CODE.key],
        [envelopesFields.CREATED_AT.key]: item[envelopesFields.CREATED_AT.key],
        [envelopesFields.DOWNLOAD_SERVER_IP_ADDRESS_PORT.key]: item[envelopesFields.DOWNLOAD_SERVER_IP_ADDRESS_PORT.key],
        [envelopesFields.SCHEDULED_START_DATE.key]: item[envelopesFields.SCHEDULED_START_DATE.key],
        [envelopesFields.SCHEDULED_END_DATE.key]: item[envelopesFields.SCHEDULED_END_DATE.key],
        [downloadCodesFields.DOWNLOAD_CODE_NAME.key]: item[downloadCodesFields.DOWNLOAD_CODE_NAME.key],
        [downloadCodesFields.CREATED_BY.key]: item[downloadCodesFields.CREATED_BY.key]
    }));

    data.items = mappedItems;
    data.totalResults = totalResults;
    return data;
}

const queryGetDownloadCodes = ({ query }, enabled) => {
    return {
        queryKey: [DOWNLOAD_CODES.COLLECTION.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(DOWNLOAD_CODES.COLLECTION.url, query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetDownloadCodes;